import {
  Button,
  ButtonUtility,
  Table,
  TableCard,
} from "@light-technology/components";
import { Trash01 } from "@untitledui/icons";
import { format } from "date-fns";
import { api } from "../../state/api";
import { type AppResponse } from "../../state/api.types";
import { CreateKeyModal } from "./CreateKeyModal";
import { DeleteKeyModal } from "./DeleteKeyModal";

type KeysCardProps = {
  app: AppResponse;
};

export const KeysCard = (props: KeysCardProps) => {
  const getApiKeys = api.useGetApiKeysQuery(props.app.uuid);
  return (
    <TableCard.Root>
      <TableCard.Header
        title="App tokens"
        description={
          <>
            Use app tokens for the App API to create new accounts and more.{" "}
            <a
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
              href="https://docs.light.dev/authentication"
            >
              Learn more
            </a>
          </>
        }
        contentTrailing={
          <CreateKeyModal app={props.app}>
            <Button data-ph-capture-attribute-action="create-api-token">
              Create token
            </Button>
          </CreateKeyModal>
        }
      />
      <Table aria-label="App tokens">
        <Table.Header>
          <Table.Head isRowHeader id="name" label="Name" />
          <Table.Head id="clientId" label="Client ID" />
          <Table.Head id="created" label="Created" />
          <Table.Head id="lastUsed" label="Last used" />
          <Table.Head id="actions" label="" className="w-0 whitespace-nowrap" />
        </Table.Header>
        <Table.Body>
          {!getApiKeys.data?.data.length ? (
            <Table.Row>
              <Table.Cell colSpan={5}>
                <div className="flex flex-col items-center justify-center gap-lg p-5xl">
                  <div className="text-sm text-tertiary">
                    No app tokens created yet.
                  </div>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : (
            getApiKeys.data.data.map((key) => (
              <Table.Row key={key.client_id}>
                <Table.Cell>{key.name}</Table.Cell>
                <Table.Cell>{key.client_id}</Table.Cell>
                <Table.Cell>{format(key.created_at, "PPP")}</Table.Cell>
                <Table.Cell>
                  {key.last_used_at ? format(key.last_used_at, "PPP") : "-"}
                </Table.Cell>
                <Table.Cell>
                  <DeleteKeyModal app={props.app} clientId={key.client_id}>
                    <ButtonUtility size="xs" color="tertiary" icon={Trash01} />
                  </DeleteKeyModal>
                </Table.Cell>
              </Table.Row>
            ))
          )}
        </Table.Body>
      </Table>
    </TableCard.Root>
  );
};
